module.exports = __webpack_public_path__ + "img/detection_03.c8250815.jpg";